import { ThemeOptions } from '@mui/material';

export const generateListThemeOptions = (): ThemeOptions['components'] => ({
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: '36px', // Reduce spacing between icon and text
      },
    },
  },
});
